const market = {
  dsbz: "Danh sách tiền tệ sắp được niêm yết",
  kpsj: "Đếm ngược đến thời gian mở cửa/Thời gian mở cửa",
  ykp: "Đã mở",
  kpdjs: "Đếm ngược đến giờ mở cửa",
  worning: "Không phải là giá giao dịch cuối cùng, chỉ để tham khảo",
  swapTab_1: "Hợp đồng theo USDT",
  swapTab_2: "Hợp đồng theo Coin",
  searchCoin: "Tìm kiếm đồng coin",
  risk: "Cảnh báo rủi ro",
  addSelfCode: "Thêm vào danh sách tự chọn",
  pair: "Cặp giao dịch",
  latestPrice: "Giá mới nhất",
  changeHour: "Biến động giá trong 1 giờ",
  highHour: "Giá cao nhất trong 24 giờ",
  lowHour: "Giá thấp nhất trong 24 giờ",
  priceTrend: "Xu hướng giá (3 ngày)",
  volumeHour: "Khối lượng giao dịch trong 24 giờ",
  noSearch: "Không có kết quả tìm kiếm",
  noAdd: "Chưa thêm vào tự chọn",
  noYet: "Chưa có sẵn đồng coin này",
  noBi: "Chưa có sẵn đồng coin",
  wan: "Vạn",
  qian: "Ngàn",
  yi: "Tỷ",
  yxhy: "Hợp đồng vĩnh viễn",
  wghy: "Hợp đồng lưới",
  cxjy: "Khu vực Giao dịch Đổi mới có nhiều thành công về mặt kỹ thuật và thị trường, nhưng giá cả dao động lớn và rủi ro cũng tương đối cao. Chúng tôi khuyến nghị bạn kiểm tra kỹ thông tin liên quan và quyết định có tham gia hay không trong khả năng chịu đựng của bạn.",
  qljy: "Khu vực Giao dịch Tiềm năng đang ở giai đoạn phát triển sớm của thị trường, BiKing không thể đảm bảo giá trị chung và tình hình lưu thông trên thị trường. Vui lòng xem xét thông tin dự án cẩn thận trong khả năng chịu đựng của bạn trước khi tham gia đầu tư.",
  qljyDao:
    "Khu vực Giao dịch DAO đang ở giai đoạn phát triển sớm của thị trường, BiKing không thể đảm bảo giá trị chung và tình hình lưu thông trên thị trường. Vui lòng xem xét thông tin dự án cẩn thận trong khả năng chịu đựng của bạn trước khi tham gia đầu tư.",
  default:
    "Khu vực Giao dịch đang ở giai đoạn phát triển sớm của thị trường, BiKing không thể đảm bảo giá trị chung và tình hình lưu thông trên thị trường. Vui lòng xem xét thông tin dự án cẩn thận trong khả năng chịu đựng của bạn trước khi tham gia đầu tư.",
  storage:
    "Khu vực Giao dịch Lưu trữ đang ở giai đoạn phát triển sớm của thị trường, BiKing không thể đảm bảo giá trị chung và tình hình lưu thông trên thị trường. Vui lòng xem xét thông tin dự án cẩn thận trong khả năng chịu đựng của bạn trước khi tham gia đầu tư.",
  dlt: "Khu vực Giao dịch với Số lượng lưu thông thấp có tính thanh khoản thấp, tồn tại rủi ro bị rút khỏi thị trường. Trước khi tham gia đầu tư, chúng tôi khuyến nghị bạn xem xét một cách cẩn thận.",
  defi: "Khu vực Giao dịch DEFI đang ở giai đoạn phát triển sớm của thị trường, BiKing không thể đảm bảo giá trị chung và tình hình lưu thông trên thị trường. Vui lòng xem xét thông tin dự án cẩn thận trong khả năng chịu đựng của bạn trước khi tham gia đầu tư.",
  nft: "Khu vực Giao dịch NFT đang ở giai đoạn phát triển sớm của thị trường, BiKing không thể đảm bảo giá trị chung và tình hình lưu thông trên thị trường. Vui lòng xem xét thông tin dự án cẩn thận trong khả năng chịu đựng của bạn trước khi tham gia đầu tư.",

  hz: "Vĩnh viễn",
  yx: "Tìm hiểu",
  yjyzx: "Dự án do Viện Nghiên cứu lựa chọn",
  zx: "Tự chọn",
  bb: "Tiền mặt",
  hy: "Hợp đồng",
  zfb: "Bảng tăng giảm",
  xbb: "Bảng đồng coin mới",
  bd: "Cặp giao dịch",
  zxj: "Giá mới nhất",
  zdf24: "Biến động giá 24 giờ",
  high24: "Giá cao nhất 24 giờ",
  low24: "Giá thấp nhất 24 giờ",
  turnover24: "Khối lượng giao dịch 24 giờ",
  zd24: "Biến động giá 24 giờ",
  zjrzd: "Giá / Biến động hàng ngày",
  scgl: "Tổng quan thị trường",
  jysj: "Dữ liệu giao dịch",
  fyje: "Số tiền hoa hồng",
  不允许任何用户通过多:"Do những thay đổi trong môi trường thị trường, tồn tại rủi ro gian lận và các lý do khác, Biking có quyền cuối cùng thực hiện các điều chỉnh đối với quy tắc giảm giá bất kỳ lúc nào. ",
  交易人数: "Số lượng nhà giao dịch",
  使用你的推荐链接: " dùng đăng ký bằng liên kết giới thiệu hoặc mã giới thiệu của bạn được coi là người được mời của bạn. Nếu người dùng không điền mã giới thiệu khi đăng ký, mối quan hệ lời mời sẽ không được thiết lập;",
  保留对活动的最终解释权:"Biking  đi xe đạp có quyền giải thích cuối cùng về sự kiện này.",
  合约交易返佣: "Nhận giảm giá cho các giao dịch hợp đồng có giá trị cao",
  合约手续费: "Phí xử lý hợp đồng ",
  合约返佣: "Giảm giá hợp đồng",
  好友返佣比例: "Tỷ lệ giảm giá của bạn bè",
  我的返佣比例: "Tỷ lệ giảm giá của tôi",
  推荐人数: "Số lượt giới thiệu",
  推荐好友: "Giới thiệu bạn bè",
  推荐总览: "Tổng quan về đề xuất ",
  推荐码: "Mã đề xuất",
  推荐记录: "Hồ sơ đề xuất",
  是否交易: "Có nên giao dịch không",
  注册时间: "Thời gian đăng ký (UTC+8)",
  用户邀请朋友无上限:"Không người dùng nào được phép tự mời qua nhiều tài khoản. phí xử lý của tài khoản được mời sẽ được hoàn lại, Không có giới hạn tối đa cho người dùng mời bạn bè;",
  由于市场环境的改变:"Người đi xe đạp có quyền giải thích cuối cùng về sự kiện. Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với dịch vụ khách hàng. ",
  被邀请人产生的真实交易手续费:"Đối với phí giao dịch thực do người mời tạo ra, người mời có thể nhận được hoa hồng tương ứng với phí giao dịch, số tiền này sẽ được trả lại vào tài khoản của người mời vào ngày hôm sau. Thời gian gửi tiền cụ thể sẽ là sau 4 giờ hàng ngày.;",
  被邀请人只有进行合约: "Không có giới hạn tối đa cho người dùng mời bạn bè;",
  请输入账户UID: "Vui lòng nhập UID tài khoản",
  账户UID: "UID tài khoản",
  返佣活动规则说明: "Mô tả quy tắc hoạt động giảm giá:",
  返佣记录: "Hồ sơ giảm giá",
  ms: "Có",
  mf: "Không",
  推荐链接:'Liên kết',
  一键分享:'Chia sẻ',
};

export { market };



// WEBPACK FOOTER //
// ./src/i18n/lang/market/vi.js